import { default as aboutkQVZo3B8IxMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/about.vue?macro=true";
import { default as _91id_938F65HYDl22Meta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/cert/[id].vue?macro=true";
import { default as homef2vgNM5EIXMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/home.vue?macro=true";
import { default as indexIvmPoZaR8ZMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/index.vue?macro=true";
import { default as _91id_933kOy0CEGAfMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/news/[id].vue?macro=true";
import { default as indexVeRjyifiLpMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/news/index.vue?macro=true";
import { default as policyZcan120YLaMeta } from "/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/policy.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/about.vue").then(m => m.default || m)
  },
  {
    name: "cert-id",
    path: "/cert/:id()",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/cert/[id].vue").then(m => m.default || m)
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/home.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexIvmPoZaR8ZMeta || {},
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "policy",
    path: "/policy",
    component: () => import("/Users/haoli/Documents/code/guoxin/aiscpt/frontend/live_pc/src/pages/policy.vue").then(m => m.default || m)
  }
]